<template>
  <div class="sn-f-e-c app-header">
    <template v-if="loginCondition">
      <div>{{ $sn.encrypted.phone($sn.utils.getLoginPhone()) }}</div>
      <div class="sn-pointer" @click="navigateUrl('/login/register', '', {
        mode: '3'
      });">个人中心</div>
      <div class="sn-pointer" @click="exit();">退出</div>
    </template>
    <template v-else>
      <div class="sn-pointer" @click="navigateUrl('/login');">登录</div>
      <div class="sn-pointer" @click="navigateUrl('/login/register', '', {
        mode: '1'
      });">用户注册</div>
    </template>
  </div>
</template>
<script type="text/javascript">
import * as Messages from '@/common/utils/messages';
import * as Tools from '@/common/utils/tools';

export default {
  name: 'app-header',
  data() {
    return {
      loginCondition: false
    };
  },
  watch: {
    '$route': {
      handler: function() {
        this.loginCondition = this.$sn.utils.getLoginCondition();
      },
      immediate: true
    }
  },
  methods: {
    exit() {
      this.$sn.assembly.modal({
        caption: Messages.C015,
        success: (modal) => {
          if (modal.confirm) {
            this.loginCondition = false;
            Tools.removeLoginInformation();
            this.navigateUrl('/', '', {}, 'replace');
          }
        }
      });
    },
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === '') {
      }
      else if (url.substring(0, 4) === 'http' || url.substring(0, 7) === '/static' || url.substring(0, 2) === '//') {
        window.location.href = url;
      }
      else {
        this.$router[type]({
          path: url,
          query: params || {}
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.app-header {
  @include fs(16);

  width: 100%;
  height: 40px;
  background-color: $main;
  color: $white;
  padding-right: 10%;

  div {
    margin-right: 40px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
